<template>
  <button 
    @click="$emit('navigate', screenName)"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    class="cursor-pointer flex flex-col items-center justify-center p-2 transition-all duration-200 w-16"
  >
    <div class="mb-1">
      <component 
        :is="iconComponent"
        class="h-6 w-6"
        :style="{
          color: iconColor,
          transition: 'color 0.3s ease'
        }"
      />
    </div>
    <span 
      class="text-xs font-medium"
      :style="{
        color: textColor,
        transition: 'color 0.3s ease'
      }"
    >
      {{ label }}
    </span>
  </button>
</template>

<script>
import { 
  AkChatDots,
  AkHomeAlt1, 
  AkQuestion, 
  AkClock 
} from '@kalimahapps/vue-icons';

export default {
  name: 'NavButton',
  components: {
    AkHomeAlt1,
    AkChatDots,
    AkQuestion,
    AkClock
  },
  props: {
    screenName: {
      type: String,
      required: true
    },
    currentScreen: {
      type: String,
      required: true
    },
    iconComponent: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    inactiveColor: {
      type: String,
      default: '#737373' // text-neutral-600
    }
  },
  emits: ['navigate'],
  data() {
    return {
      isHovered: false
    }
  },
  computed: {
    isActive() {
      return this.currentScreen === this.screenName;
    },
    iconColor() {
      if (this.isActive) return '#000000'; // black
      if (this.isHovered) return '#000000'; // black on hover
      return this.inactiveColor; // neutral color
    },
    textColor() {
      if (this.isActive) return '#000000'; // black
      if (this.isHovered) return '#000000'; // black on hover
      return this.inactiveColor; // neutral color
    }
  },
  methods: {
    handleMouseEnter() {
      this.isHovered = true;
    },
    handleMouseLeave() {
      this.isHovered = false;
    }
  }
}
</script>